import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import { Icon, theme, ListItem } from 'components';
import RouteListingOrStop from './RouteListingOrStop';
import TourEditContext from '../TourEditContext';

const CancelledShowingsList: React.FC = () => {
  const [showCancelledShowings, setShowCancelledShowings] = useState(false);

  const { cancelledTourItems } = useContext(TourEditContext);

  if (!cancelledTourItems?.length) {
    return null;
  }

  return (
    <>
      <StyledShowHideContainer>
        <Icon
          type={showCancelledShowings ? 'minus' : 'plus'}
          color="info"
          offset={[0, 22]}
        />
        <StyledText
          onClick={() => setShowCancelledShowings(!showCancelledShowings)}
          data-cy="show-hide-cancelled-listings"
        >
          {showCancelledShowings ? 'Hide' : 'View'} cancelled / denied showings
        </StyledText>
      </StyledShowHideContainer>
      {showCancelledShowings
        ? cancelledTourItems.map(item => (
            <RouteListingOrStop key={item.id} item={item} />
          ))
        : null}
    </>
  );
};

export default CancelledShowingsList;

const StyledShowHideContainer = styled.div`
  color: ${theme.blueBase};
  display: flex;
  margin: 0 24px;
`;

const StyledText = styled.p`
  margin: 20px 0 20px 3px;
  cursor: pointer;
  font-size: 14px;
`;
